import getApiConfig from '../config/apiConfig';

// Helper function to handle API responses
const handleResponse = async (response) => {
  if (!response.ok) {
    const error = await response.text();
    throw new Error(error);
  }
  return response.json();
};

const salesPersonService = {
  // Get all salespersons
  async getSalesPersons() {
    try {
      const { apiBaseUrl } = getApiConfig();
      const response = await fetch(`${apiBaseUrl}/lookup/salespersons`);
      return handleResponse(response);
    } catch (error) {
      console.error('Error getting salespersons:', error);
      throw error;
    }
  },

  // Get salesperson by email
  async getSalesPersonByEmail(email) {
    try {
      const { apiBaseUrl } = getApiConfig();
      const response = await fetch(`${apiBaseUrl}/lookup/salespersons/${encodeURIComponent(email)}`);
      return handleResponse(response);
    } catch (error) {
      console.error('Error getting salesperson by email:', error);
      throw error;
    }
  },

  // Create salesperson if not exists
  async createSalesperson(email, name, initials) {
    try {
      const { apiBaseUrl } = getApiConfig();
      const response = await fetch(`${apiBaseUrl}/lookup/salespersons`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email, name, initials })
      });
      return handleResponse(response);
    } catch (error) {
      console.error('Error creating salesperson:', error);
      throw error;
    }
  }
};

export default salesPersonService; 